import { ChangeDetectionStrategy, Component, inject, model, ViewEncapsulation } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ProfileInfoComponent } from '@layout/profile-menu/components/profile-info/profile-info.component';
import { NavigationFacade } from '@core/navigation/facades/navigation.facade';
import { TopNavigationPath } from '@core/navigation/models/top-navigation/top-navigation-path';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { PrefetchLinkDirective } from '@kaseya-design-components';
import { HelpTogglePanelComponent } from '@layout/help-menu/components/help-toggle-panel/help-toggle-panel.component';
import { NotificationsTogglePanelComponent } from '@layout/notifications/components/notifications-toggle-panel/notifications-toggle-panel.component';
import { PermissionDirective } from '@core/permissions/directives/permission.directive';
import { getHeaderHeight } from '@shared/utils/header-height';
import { ThemeTogglePanelComponent } from '@layout/help-menu/components/theme-toggle-panel/theme-toggle-panel.component';
import { ApplicationPath } from '@core/navigation/models/application-path.enum';
import { Permission } from '@kaseya-shared';

@Component({
  selector: 'itc-header-utilities-panel',
  templateUrl: 'header-utilities-panel.component.html',
  styleUrl: 'header-utilities-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [
    TranslatePipe,
    ProfileInfoComponent,
    RouterLink,
    PrefetchLinkDirective,
    RouterLinkActive,
    HelpTogglePanelComponent,
    NotificationsTogglePanelComponent,
    PermissionDirective,
    ThemeTogglePanelComponent,
  ],
})
export class HeaderUtilitiesPanelComponent {
  private readonly navigationFacade = inject(NavigationFacade);
  private readonly activeTopNavigation = this.navigationFacade.activeTopNavigation;

  readonly isOpen = model(false);
  readonly settingsNavigationItems = this.navigationFacade.settingsNavigationItems;
  readonly headerHeight = getHeaderHeight();
  readonly ApplicationPath = ApplicationPath;
  readonly Permission = Permission;

  handleSettingsNavigationClick(id: TopNavigationPath): void {
    this.isOpen.set(false);
    this.setActiveTopNavigation(id, true);
  }

  setActiveTopNavigation(topNavigation: TopNavigationPath, isActive: boolean): void {
    if (isActive && this.activeTopNavigation() !== topNavigation) {
      this.navigationFacade.setActiveTopNavigation(topNavigation);
    }
  }
}
